import * as React from 'react';
import { RootState } from '../store';
import { Action, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { returntypeof } from '../helper';
import { CLEAR_PHOTOS, Photo, TOGGLE_SELECT_PHOTO } from '../store/photos';
import { TOGGLE_CHECKOUT, TOGGLE_THANKYOU, UPDATE_FORM } from '../store/login';
import PhotoBrick from './PhotoBrick';
import { Node, SELECT_PROFILE, COLLAPSE_MENU } from '../store/profile';
import Westpac from './gateways/Westpac';
import { copyFileSync } from 'fs';
import Termsandconditions from './Termsandconditions';
import Disclaimer from './Disclaimer';
import { PayPalButton } from 'react-paypal-button-v2';
import { LineItem, SUBMIT_PAYMENT, PaymentRequest, PaypalRequest, SUBMIT_PAYPAL, EmailRequest, SEND_EMAIL } from '../store/webshop';
import Sidebar from './Sidebar';

const mapStateToProps = (state: RootState) => ({
    login: state.login,
    selected: state.photo.selected,
    webshop: state.webshop,
    bricks: state.photo.bricks,
    communitybricks: state.photo.communitybricks,
    rendition_type: state.login.rendition_type,
    payment_gateway: state.login.payment_gateway,
    photo: state.photo,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleCheckout: () => {
        dispatch({ type: TOGGLE_CHECKOUT })
    },
    onSelect: (id: string) => {
        dispatch({ type: TOGGLE_SELECT_PHOTO, id });
    },
    toggleThankyou: () => {
        dispatch({ type: TOGGLE_CHECKOUT })
        dispatch({ type: TOGGLE_THANKYOU })
    },
    toggleFilter: (selected?: number) => {
        dispatch({ type: SELECT_PROFILE, selected })
    },
    submitPayment: (request: PaymentRequest) => {
        dispatch({ type: SUBMIT_PAYMENT, request })
    },
    submitPaypal: (request: PaypalRequest) => {
        dispatch({ type: SUBMIT_PAYPAL, request })
    },
    sendEmail: (request: EmailRequest) => {
        dispatch({ type: SEND_EMAIL, request })
    },
    onClear: () => {
        dispatch({ type: CLEAR_PHOTOS })
    }
});


const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

interface CreditCardFrame {
    getToken: (cb: TokenCallback) => void;
}


type TokenCallback = (err: any, data: CallbackData) => void;

interface CallbackData {
    paymentMethod: string,
    singleUseTokenId: string
}

type State = {
    loaded: boolean,
    showCredit: boolean,
    frame?: CreditCardFrame
    email?: string
    sendEmail: boolean,
    cart?: Photo[]
}

class Checkout extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        if (this.props.login.paypal_gateway == undefined || this.props.login.paypal_gateway.active == false) {
            this.state = {
                loaded: false,
                showCredit: true,
                email: "",
                sendEmail: false,
            }
        }
        else {
            this.state = {
                loaded: false,
                showCredit: false,
                email: "",
                sendEmail: false,
            }
        }


        this.props.photo.filters = [];
        this.props.toggleFilter();
        this.setState({ email: this.props.login.email })
        
        
    }

    removePhoto = (photo: Photo) => (e: React.MouseEvent<any>) => {
        this.props.onSelect(photo.id);
        this.setState({ loaded: true })
        e.stopPropagation();
        e.preventDefault();
    }

    removeAllPhoto = (cart: Photo[]) => {
        cart.forEach(photo => {
            this.props.onSelect(photo.id);
        })
        this.setState({ loaded: true });
    }

    displayPhoto = (photo: Photo) => {

        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let src = `/api/v1/preview/${this.props.rendition_type}/${photo.id}?sbpportal-ticket=${ticket}`;

        let cost = photo.cost == undefined ? 0 : photo.cost as number;

        let title;
        let year;
        let res;
        let size;

        if (photo.sb_event != null) {
            title = photo.sb_event.toString().substring(0, 100)
        }

        if (photo.sb_year != null) {
            year = photo.sb_year
        }

        if (photo.exif_pixelXDimension != null && photo.exif_pixelYDimension != null) {
            res = "Resolution: " + photo.exif_pixelXDimension + "x" + photo.exif_pixelYDimension;
        }

        if (photo.size != null) {
            size = (photo.size as number / 1000000).toFixed(2) + " MB"
        }

        return (
            <tr>
                <td className="product-thumbnails"><img src={src} alt=""></img></td>
                <td className="product-info">
                    <h6>{title}</h6>
                    <div className="text-muted">{year}</div>
                    <ul>
                        <li className="size">{res}</li>
                        <li className="color">{size}</li>
                    </ul>
                </td>
                <td className="price"><span>${cost.toFixed(2)}</span></td>
                <td><a className="remove-product" onClick={this.removePhoto(photo)}>x</a></td>
            </tr>

        )
    }



    calculateTotal = () => {

        let cart = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)) as Photo[];

        let community = this.props.communitybricks.filter(communitybricks => communitybricks.type == "photo" && this.props.selected.has(communitybricks.id)) as Photo[];

        let newCart: Photo[] = [];

        cart = cart.concat(community);

        cart.forEach(element => {
            let found = false;
            for(var i=0; i < newCart.length; i++){
                if(newCart[i].id == element.id){
                    found = true;
                    continue;
                }
            }
            if(!found){
                newCart.push(element);
            }
            
        });

        cart = newCart;


        let cartTotal = cart.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;

            let cost = item.cost as number;

            if (this.props.webshop.orders.has(item.id)) {
                return 0;
            } else {
                return cost;
            }

        }).reduce((a, b) => a + b, 0);

        return cartTotal;

    }

    onDownloadClick = (cart: Photo[]) => (e: React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let ids = cart.map(photo => photo.id).join(",");

        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();
    }

    showWestpac = (e: React.FormEvent<HTMLInputElement>) => {


        let value = e.currentTarget.value;
        if (value == "creditCard" && !this.state.showCredit) {
            this.setState({ showCredit: true })
        }
        else if (value != "creditCard" && this.state.showCredit) {
            this.setState({ showCredit: false })
        }
    }

    handleEmail = (event: { target: any; }) => {
        const target = event.target;
        const targetName = target.name as string;
        const value = target.value as string;

        this.setState({ email: value })
    }


   /* sendEmail = () => {
        let email = this.buildEmail();
        this.props.sendEmail(email);
        this.setState({ sendEmail: false }, () => this.props.toggleThankyou)
    } */


    buildEmail = () => {


        let items: LineItem[] = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;
            return {
                id: item.id,
                name: item.cm_description as string,
                cost: this.props.webshop.orders.has(item.id) ? 0 : item.cost as number
            }

        });

        let to = this.state.email == undefined ? "" : this.state.email.toString();
        let subject = "Transaction Receipt for ";
        let subtotal = this.calculateTotal();
        let transaction_id = "1";



        return {
            to,
            subject,
            items,
            transaction_id,
            subtotal
        }
    }

    buildPaypalRequest = (details: any) => {

        /* 
            transaction_id: string
            username: String,
            Items: 
            status: String
            */

           let cart = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)) as Photo[];

           let community = this.props.communitybricks.filter(communitybricks => communitybricks.type == "photo" && this.props.selected.has(communitybricks.id)) as Photo[];
   
           let newCart: Photo[] = [];
   
           cart = cart.concat(community);
   
           cart.forEach(element => {
               let found = false;
               for(var i=0; i < newCart.length; i++){
                   if(newCart[i].id == element.id){
                       found = true;
                       continue;
                   }
               }
               if(!found){
                   newCart.push(element);
               }
               
           });

           cart = newCart;


        let items: LineItem[] = cart.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)).map(photo => {

            let item = photo as Photo;

            return {
                id: item.id,
                name: "test",
                cost: this.props.webshop.orders.has(item.id) ? 0 : item.cost as number
            }

        });


        return {
            transaction_id: details.purchase_units[0].payments.captures[0].id,
            username: this.props.login.username,
            email: this.props.login.email,
            items: items,
            status: details.status
        }
    }

    onPaypalsubmit = (details: any, result: any) => {
        let request = this.buildPaypalRequest(details);
        if (details.status == "COMPLETED") {
            this.props.submitPaypal(request);
            this.props.webshop.result = {
                transaction_id: details.purchase_units[0].payments.captures[0].id,
                username: request.username,
                items: request.items,
                status: "approved"
            }
            this.props.webshop.vendor = "paypal";
            this.props.toggleThankyou(); 
        }
    }

    onPaypalClick = (details: any, action: any) => {
        action.order.capture().then((details: any, result: any) => {
            this.onPaypalsubmit(details, result);
        });
    }

    onDownloadAllClick = (cart: Photo[]) => (e: React.MouseEvent<any>) => {
        let ticket = encodeURIComponent(this.props.login.ticket || "");

        let ids = cart.map(photo => photo.id).join(",");

        window.open(`/api/v1/download/original/${ids}?sbpportal-ticket=${ticket}`, "_blank");

        e.stopPropagation();
        e.preventDefault();

        this.props.onClear();
        this.props.toggleCheckout();
    }

    inIframe = () => {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    public render() {

        let logo;
        if(!this.inIframe()){
            logo = <p className="float-left"><img src="/api/asset/logo" alt="" width="180px" height="auto"></img></p>
        }

        if (this.props.webshop.submitted) {
            this.props.toggleThankyou();
        }

        let cart = this.props.bricks.filter(brick => brick.type == "photo" && this.props.selected.has(brick.id)) as Photo[];

        let community = this.props.communitybricks.filter(communitybricks => communitybricks.type == "photo" && this.props.selected.has(communitybricks.id)) as Photo[];

        let newCart: Photo[] = [];

        cart = cart.concat(community);

        cart.forEach(element => {
            let found = false;
            for(var i=0; i < newCart.length; i++){
                if(newCart[i].id == element.id){
                    found = true;
                    continue;
                }
            }
            if(!found){
                newCart.push(element);
            }
            
        });

        cart = newCart;


        let totalText;
        let headerText;
        let orderSumBtn;
        let emptyBtn;

        let westpac;
        if (this.props.payment_gateway != undefined && this.props.payment_gateway.vendor == "westpac") {
            westpac = <Westpac publicKey={this.props.payment_gateway.public_key} />;
        }

        emptyBtn = <div className="float-right">
            <a data-toggle="modal" data-target="#confirm-delete" data-toggle-class="fade-down" data-toggle-class-targets="#animate"><button className="btn btn-danger btn-terms"><img src="/assets/icons/cancel.png"></img> Empty Cart</button></a>
        </div>


        totalText = "$" + this.calculateTotal().toFixed(2)
        if (this.calculateTotal() > 0) {
            headerText = <h1>Your basket</h1>
            orderSumBtn = <div className="float-left">
                <a onClick={this.props.toggleCheckout} style={{ cursor: 'pointer' }} className="text-muted"><img className="checkout-lock" src="assets/icons/chevron_left.png" /> Back to <strong>Gallery</strong></a>
            </div>

        }

        let creditStyle = "none";
        if (this.state.showCredit) {
            creditStyle = "list-item";
        }

        let noItems;
        if (cart.length == 0) {
            noItems = <h2 className="main-title">Your basket is empty</h2>
            emptyBtn = null;
        }

        let showPaypal;
        if (this.props.login.paypal_gateway != undefined && this.props.login.paypal_gateway.active == true) {
            showPaypal = <li>
                <input type="radio" value="paypal" id="paypalradio" className="payment-radio-button" onClick={this.showWestpac} checked={!this.state.showCredit} />
                <label htmlFor="paypalradio">PayPal <img className="checkout-svg" src="/assets/icons/paypal.svg" width="auto" height="30px"></img></label>
            </li>
        }

        let showWestpac;
        if (this.props.login.payment_gateway != undefined && this.props.login.payment_gateway.active == true && this.props.login.currency.toUpperCase() != "NZD") {
            showWestpac = <li>
                <input type="radio" value="creditCard" id="credit-card" className="payment-radio-button" onClick={this.showWestpac} checked={this.state.showCredit} />
                <label htmlFor="credit-card" >Credit Card <img className="checkout-svg" src="/assets/icons/mastercard.svg" /> <img className="checkout-svg" src="/assets/icons/visa.svg" /> <img className="westpack" src="/assets/icons/westpac_transparent.png"></img></label>
            </li>
        }

        let checkoutButton;
        let emailElement;

        let paypalButton;
        if (this.props.login.paypal_gateway && this.props.login.paypal_gateway.active == true) {
            let ClientId = this.props.login.paypal_gateway.client_id;
            paypalButton = <PayPalButton shippingPreference="NO_SHIPPING" style={{ layout: 'horizontal' }} createOrder={(data:any, actions: any) => { return actions.order.create({ purchase_units: [{ amount: { currency: "AUD", value: this.calculateTotal().toFixed(2)}}]})}}  onApprove={(details: any, action: any) => { this.onPaypalClick(details, action) }}  options={{ clientId: ClientId, currency: this.props.login.currency }} />
        }
        
        
        if (this.state.showCredit || this.props.login.paypal_gateway == undefined || this.props.login.paypal_gateway.active == false) {
            emailElement = <p className="pt-15">
                <i>Send a receipt to:</i>
                <input className="email-receipt" type="email" value={this.state.email} onChange={this.handleEmail} placeholder="Email address"></input>
            </p>
        }
        else {
            if (this.props.login.paypal_gateway && this.props.login.paypal_gateway.active == true) {
                let ClientId = this.props.login.paypal_gateway.client_id;
                if (this.calculateTotal() > 0) {
                    checkoutButton = <>
                            <p className="policy-text">You will be able to download your pictures, after payment</p>
                            {paypalButton}   
                        </>
                }
            }

        }

        let orderReview;
        if (this.calculateTotal() > 0) {
            orderReview =
                <>
                    <img className="checkout-lock" src="/assets/icons/lock.svg" />
                    <h2 className="main-title">Checkout</h2>
                    <div className="order-review">
                        <table className="product-review">
                            <tbody>
                                <tr>
                                    <th><span>Total</span></th>
                                    <td><span>{totalText}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <div><span className="text-muted small">Select your Payment method</span></div>
                        <div className="payment-option">
                            <ul className="payment-list">
                                {showPaypal}
                                {showWestpac}
                                <li className="credit-card-form" style={{ display: creditStyle }}>
                                    {westpac}
                                </li>
                            </ul>
                        </div>
                        {checkoutButton}
                    </div>
                </>
        }

        if (this.calculateTotal() == 0 && cart.length > 0) {
            orderReview = <>
                <img className="checkout-lock" src="/assets/icons/lock.svg" />
                <h2 className="main-title">Checkout</h2>
                <div className="order-review">
                    <table className="product-review">
                        <tbody>
                            <tr>
                                <th><span>Total</span></th>
                                <td><span>{totalText}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <div><span className="text-muted small">Click to download all images</span></div>
                    <p>
                        <button type="button" className="btn btn-add-cart btn-block" onClick={this.onDownloadAllClick(cart)} ><img className="add-cart-white" src="assets/icons/download.png" height="26px" width="auto" /><img className="add-cart-blue" src="assets/icons/download_blue.png" height="26px" width="auto" /> Download All</button>
                    </p>
                </div>

            </>
        }


        return <div className="checkout-section pt-90 pb-100">
            <div className="container">

                <div className="checkout-form">
                    <div className="row">
                        <div className="col-lg-6 cart-list-form">
                            <div className="row pb-30">
                                <div className="col-12">
                                    {logo}
                                </div>
                            </div>

                            {noItems}
                            <div className="pb-70 d-sm-block float-left" style={{ cursor: "pointer" }}>
                                <a className="text-muted" onClick={this.props.toggleCheckout} ><img className="checkout-lock" src="assets/icons/chevron_left.png" /> Back to <strong>Gallery</strong></a>
                            </div>
                            <div className="table-responsive">
                                <table className="table">
                                    <tbody>
                                        {cart.map(this.displayPhoto)}
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-between cart-footer">

                                <div className="cart-total-section">
                                    <table className="cart-total-table">
                                        <tbody>
                                            <tr>
                                                <th>Total</th>
                                                <td>{totalText}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {emptyBtn}

                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div className="order-confirm-sheet">

                                {orderReview}

                                <div className="mt-70">
                                    <p className="float-right">Powered by <img src="/assets/icons/logo.jpg" alt="" width="160px" height="auto"></img></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="confirm-delete" className="modal fade show" data-backdrop="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Are you sure you want to empty cart?</h5>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button className="btn btn-danger btn-terms" onClick={() => this.removeAllPhoto(cart)} data-dismiss="modal"><img src="/assets/icons/cancel.png"></img> Empty Cart</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);